export enum ECategoryNameIDMap {
  follow = '72',
  foryou = '0',
  health = '2',
  food = '12', // 日本 & 泰国 & 印尼
  food_guide = '616', // 日本分拆美食探店频道
  food_recipe = '615', // 日本分拆美食食谱频道
  lifestyle = '19',
  beauty = '569',
  fashion = '570',
  travel = '20',
  profile = '486', // user profile
  poi = '650', // position
  hashtag_channel_recent = '585', // hashtag post by timing
  hashtag_channel_hot = '590', // hashtag post by trending
  relation = '61', // relation article
  pet = '37',
  fitness = '674',
  home = '14',
  productivity = '685',
  reading = '686',
  photography = '669',
  skincare = '668',
  self_growth = '673',
  makeup = '701',
  hair = '702',
  nail = '703',
  outfits = '704',
  skincare_category = '705',
  nails = '706',
  home_category = '707',
  recipes = '708',
  makeup_category = '709',
  hair_style = '710',
  fitness_category = '711',
  accessories = '712',
  mental_health = '714',
  perfume = '715',
  relationship = '677',
  baking = '716',
  shoes = '717',
  wellness = '718',
  music = '216',
  travel_category = '719',
  tattoo = '720',
  drinks = '721',
  home_skills = '723',
  bags = '724',
  movie = '368',
  outdoors = '665',
  tech = '726',
  art_design = '728',
  gardening = '729',
  career = '730',
  games = '731',
  education = '732',
  cars = '687',
  wedding = '734',
  maternity = '736',
}

export const CategoryIDNameMap: any = {
  72: 'follow',
  0: 'foryou',
  2: 'health',
  12: 'food', // 日本 & 泰国 & 印尼
  616: 'food_guide', // 日本分拆美食探店频道
  615: 'food_recipe', // 日本分拆美食食谱频道
  19: 'lifestyle',
  569: 'beauty',
  570: 'fashion',
  20: 'travel',
  486: 'profile', // user profile
  650: 'poi', // position
  585: 'hashtag_channel_recent', // hashtag post by timing
  590: 'hashtag_channel_hot', // hashtag post by trending
  61: 'relation', // relation article
  37: 'pet',
  674: 'fitness',
  /** us 新增 */
  14: 'home',
  685: 'productivity',
  686: 'reading',
  /** th 新增 */
  669: 'photography',
  668: 'skincare',
  673: 'self_growth',
  701: 'makeup',
  702: 'hair',
  703: 'nail',
  /** US CA AU NZ新增 */
  704: 'outfits',
  705: 'skincare_category',
  706: 'nails',
  707: 'home_category',
  708: 'recipes',
  709: 'makeup_category',
  710: 'hair_style',
  711: 'fitness_category',
  712: 'accessories',
  714: 'mental_health',
  715: 'perfume',
  677: 'relationship',
  716: 'baking',
  717: 'shoes',
  718: 'wellness',
  216: 'music',
  719: 'travel_category',
  720: 'tattoo',
  721: 'drinks',
  723: 'home_skills',
  724: 'bags',
  368: 'movie',
  665: 'outdoors',
  726: 'tech',
  728: 'art_design',
  729: 'gardening',
  730: 'career',
  731: 'games',
  732: 'education',
  687: 'cars',
  734: 'wedding',
  736: 'maternity',
};

export const CategoryNameIDMap = Object.keys(CategoryIDNameMap).reduce(
  (pre: any, cur: any) => ({
    ...pre,
    [CategoryIDNameMap[cur]]: cur,
  }),
  {},
);
